module.exports = __webpack_public_path__ + "static/media/thumb2.2dd88183.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Restaurant/images/thumb2.jpg
// module id = 370
// module chunks = 0